import { Yup } from '../../common/CommonExport';
import { ErrorMessages } from '../../constants/messagesAndErrors';

export const ForgotPasswordSchema = Yup.object({
    email: Yup.string().email(ErrorMessages.invalidEmail).required(ErrorMessages.enterEmail),
});
